// API service for 3D model uploads
const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:3001'

class ModelApi {
  constructor() {
    this.broadcasterLogin = null
  }

  setBroadcasterLogin(login) {
    this.broadcasterLogin = login
  }

  // Get model for a critter type
  async getModel(critterType) {
    if (!this.broadcasterLogin) return null

    try {
      const response = await fetch(
        `${API_BASE}/twitch/api/broadcaster/${this.broadcasterLogin}/models/${critterType}`
      )
      if (!response.ok) {
        if (response.status === 404) return null
        throw new Error(`Failed to fetch model: ${response.status}`)
      }
      return await response.json()
    } catch (error) {
      console.error('Error fetching model:', error)
      return null
    }
  }

  // Get all models for broadcaster
  async getAllModels() {
    if (!this.broadcasterLogin) return []

    try {
      const response = await fetch(
        `${API_BASE}/twitch/api/broadcaster/${this.broadcasterLogin}/models`
      )
      if (!response.ok) throw new Error(`Failed to fetch models: ${response.status}`)
      return await response.json()
    } catch (error) {
      console.error('Error fetching models:', error)
      return []
    }
  }

  // Upload a 3D model
  async uploadModel(critterType, modelFile, animationMap = {}, modelScale = 5.0) {
    if (!this.broadcasterLogin) throw new Error('Broadcaster login not set')

    const formData = new FormData()
    formData.append('critterType', critterType)
    formData.append('model', modelFile)
    formData.append('animationMap', JSON.stringify(animationMap))
    formData.append('modelScale', modelScale.toString())

    const response = await fetch(
      `${API_BASE}/twitch/api/broadcaster/${this.broadcasterLogin}/models`,
      { method: 'POST', body: formData }
    )

    if (!response.ok) {
      const error = await response.json()
      throw new Error(error.error || 'Failed to upload model')
    }

    return await response.json()
  }

  // Update animation map / scale
  async updateModel(critterType, animationMap, modelScale) {
    if (!this.broadcasterLogin) throw new Error('Broadcaster login not set')

    const response = await fetch(
      `${API_BASE}/twitch/api/broadcaster/${this.broadcasterLogin}/models/${critterType}`,
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ animationMap, modelScale })
      }
    )

    if (!response.ok) {
      const error = await response.json()
      throw new Error(error.error || 'Failed to update model')
    }

    return await response.json()
  }

  // Delete a model
  async deleteModel(critterType) {
    if (!this.broadcasterLogin) throw new Error('Broadcaster login not set')

    const response = await fetch(
      `${API_BASE}/twitch/api/broadcaster/${this.broadcasterLogin}/models/${critterType}`,
      { method: 'DELETE' }
    )

    if (!response.ok) {
      const error = await response.json()
      throw new Error(error.error || 'Failed to delete model')
    }

    return true
  }
}

export const modelApi = new ModelApi()
